export const SUPPLIER_CONCILIATIONS_LIST_KEY = 'SUPPLIER_CONCILIATIONS_LIST_KEY';
export const SUPPLIER_CONCILIATIONS_ONE_KEY = 'SUPPLIER_CONCILIATIONS_ONE_KEY';

export const LOGISTIC_CONCILIATIONS_ONE_KEY = 'LOGISTIC_CONCILIATIONS_ONE_KEY';
export const LOGISTIC_CONCILIATIONS_LIST_KEY = 'LOGISTIC_CONCILIATIONS_LIST_KEY';
export const MAIN_CONCILIATION_LOGISTICS = 'MAIN_CONCILIATION_LOGISTICS';

export const MAIN_CONCILIATION_WAREHOUSE = 'MAIN_CONCILIATION_WAREHOUSE';
export const WAREHOUSE_CONCILIATIONS_ONE_KEY = 'WAREHOUSE_CONCILIATIONS_ONE_KEY';
export const WAREHOUSE_CONCILIATIONS_LIST_KEY = 'WAREHOUSE_CONCILIATIONS_LIST_KEY';

export const MAIN_CONCILIATION_DC = 'MAIN_CONCILIATION_DC';
export const DC_CONCILIATIONS_ONE_KEY = 'DC_CONCILIATIONS_ONE_KEY';
export const DC_CONCILIATIONS_LIST_KEY = 'DC_CONCILIATIONS_LIST_KEY';

export const CARRIER_CONCILIATIONS_ONE_KEY = 'CARRIER_CONCILIATIONS_ONE_KEY';
export const CARRIER_CONCILIATIONS_LIST_KEY = 'CARRIER_CONCILIATIONS_LIST_KEY';
export const MAIN_CONCILIATION_CARRIER = 'MAIN_CONCILIATION_CARRIER';

export const DRIVER_CONCILIATIONS_LIST_KEY = 'DRIVER_CONCILIATIONS_LIST';
export const DRIVER_CONCILIATIONS_ONE_KEY = 'DRIVER_CONCILIATIONS_ONE_KEY';

export const REIMBURSEMENT_CONCILIATIONS_LIST_KEY = 'REIMBURSEMENT_CONCILIATIONS_LIST_KEY';
export const PRODUCER_REIMBURSEMENT_LIST_KEY = 'PRODUCER_REIMBURSEMENT_LIST_KEY';
export const PRODUCT_CONCILIATIONS_ONE_KEY = 'PRODUCT_CONCILIATIONS_ONE_KEY';
export const PRODUCT_CONCILIATIONS_SUMMARY_KEY = 'PRODUCT_CONCILIATIONS_SUMMARY_KEY';
export const OPERATIONS_CONCILIATIONS_SUMMARY_KEY = 'OPERATIONS_CONCILIATIONS_SUMMARY_KEY';

export const MAIN_CONCILIATIONS_LIST_KEY = 'MAIN_CONCILIATIONS_LIST';
export const MAIN_CONCILIATIONS_ONE_KEY = 'MAIN_CONCILIATIONS_ONE_KEY';
export const MAIN_CONCILIATION_HISTOGRAM = 'MAIN_CONCILIATION_HISTOGRAM';
export const MAIN_CONCILIATION_SUMMARY = 'MAIN_CONCILIATION_SUMMARY';

export const MAIN_CONCILIATION_SUMMARY_SUPPLIER = 'MAIN_CONCILIATION_SUMMARY_SUPPLIER';
export const MAIN_CONCILIATION_SUPPLIER = 'MAIN_CONCILIATION_SUPPLIER';

export const MAIN_CONCILIATIONS_PLATFORM_LIST_KEY_SUMMARY = 'MAIN_CONCILIATIONS_PLATFORM_LIST_KEY_SUMMARY';
export const MAIN_CONCILIATIONS_PLATFORM_LIST_KEY_TABLE = 'MAIN_CONCILIATIONS_PLATFORM_LIST_KEY_TABLE';
export const MAIN_CONCILIATIONS_ONE_KEY_PRODUCT = 'MAIN_CONCILIATIONS_ONE_KEY_PRODUCT';
export const LIST_ADJUSTMENT_CONCILIATION = 'LIST_ADJUSTMENT_CONCILIATION';
export const LIST_ADJUSTMENT_CONCILIATION_GET_ONE = 'LIST_ADJUSTMENT_CONCILIATION_GET_ONE';
